import request from '../../../shared/request'

export function getJobContacts(job_id) {
  return request(`/job/contacts/${job_id}/`)
}

export function getAllContacts() {
  return request(`/contacts/`)
}

export function addJobContact(payload) {
  return request(`/job/contacts/${payload.job_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function createJobContactGroup(payload) {
  return request(`/job/contacts/${payload.job_id}/contact-groups`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function removeJobContactGroup(payload) {
  return request(`/job/contacts/${payload.contact_id}/contact-groups`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateJobContactGroup(payload) {
  return request(`/job/contacts/${payload.contact_id}/contact-groups`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function removeJobContact(payload) {
  return request(`/job/contacts/${payload.contact_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function createContact(payload) {
  return request(`/contacts/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateJobContact(payload) {
  return request(`/job/contacts/${payload.contact_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJobContact(payload) {
  return request(`/job/contacts/${payload.job_contact_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function getCompanyContacts(payload) {
  return request(`/contacts/${payload.companyId}`)
}

export function companyCreateContact(payload) {
  return request(`/contacts/company/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function companyUpdateContact(payload) {
  return request(`/contacts/company/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function companyDeleteContact(payload) {
  return request(`/contacts/${payload.contact_id}/company?companyId=${payload.company_id}`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateJobPrimaryContact(payload) {
  return request(`/job/contacts/${payload.jobId}/primary`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/contacts.js